import { render, staticRenderFns } from "./Atlases.vue?vue&type=template&id=16c6bec1&scoped=true&"
import script from "./Atlases.vue?vue&type=script&lang=js&"
export * from "./Atlases.vue?vue&type=script&lang=js&"
import style0 from "./Atlases.vue?vue&type=style&index=0&id=16c6bec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6bec1",
  null
  
)

export default component.exports